import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  ListGroup,
  ListGroupItem,
  PageHeader,
  Grid,
  Row,
  Col
} from 'react-bootstrap';

import {
  BootstrapTable,
  TableHeaderColumn
} from 'react-bootstrap-table';

import {
  Pedestrismo,
  PedestrismoBackup,
  CombinadaSimple,
  RuralBike
} from '../constants/enums';

import {
  utilsFormatDate,
  utilsPremiacionGeneral,
  utilsPremiacionCategorias,
  utilsPremiacionGeneralLocal
} from '../utils/utilities';


export class RaceInfo extends Component {

  /*
   * =======================================================
   * PREMIACION
   * =======================================================
   */

  getHashPremiacionGeneral(
    distanceType,
    gender,
    top
  ) {

    const participantList =
      Array.isArray(
        this.props.participantList
      )
        ? this.props.participantList
        : [];


    return (
      utilsPremiacionGeneral(
        distanceType,
        participantList,
        gender,
        top
      )
      ||
      []
    );
  }


  getHashPremiacionCategorias(
    category,
    top
  ) {

    const participantList =
      Array.isArray(
        this.props.participantList
      )
        ? this.props.participantList
        : [];


    return (
      utilsPremiacionCategorias(
        participantList,
        category,
        top
      )
      ||
      []
    );
  }


  getHashPremiacionGeneralLocal(
    distanceType,
    gender,
    top
  ) {

    const participantList =
      Array.isArray(
        this.props.participantList
      )
        ? this.props.participantList
        : [];


    return (
      utilsPremiacionGeneralLocal(
        distanceType,
        participantList,
        gender,
        this.props.place || '',
        top
      )
      ||
      []
    );
  }


  /*
   * =======================================================
   * DISTANCIAS CONFIGURADAS
   * =======================================================
   */

  getConfiguredDistances() {

    const {
      distance1Type,
      distance2Type,
      distance3Type
    } = this.props;


    return [

      {
        id: 1,

        value:
          distance1Type,

        show:
          this.props.showResultsDistance1 !== false
      },

      {
        id: 2,

        value:
          distance2Type,

        show:
          distance2Type !== undefined &&
          distance2Type !== null &&
          String(
            distance2Type
          ).trim() !== ''
      },

      {
        id: 3,

        value:
          distance3Type,

        show:
          distance3Type !== undefined &&
          distance3Type !== null &&
          String(
            distance3Type
          ).trim() !== ''
      }

    ].filter(
      (distance) => {

        return (

          distance.show

          &&

          distance.value !== undefined

          &&

          distance.value !== null

          &&

          String(
            distance.value
          ).trim() !== ''
        );
      }
    );
  }


  /*
   * =======================================================
   * TABLA GENERICA PEDESTRISMO
   * =======================================================
   */

  renderPedestrianTable(
    key,
    title,
    data,
    numberLabel = 'Dorsal'
  ) {

    const options = {
      noDataText:
        'Sin atletas'
    };


    return (

      <BootstrapTable
        key={key}
        containerClass={'awards-table awards-table--pedestrian' + (!data || data.length === 0 ? ' awards-table--empty' : '')}
        data={data || []}
        options={options}
      >

        <TableHeaderColumn
          dataField="idx"
          isKey
          hidden
        >
          Puesto
        </TableHeaderColumn>


        <TableHeaderColumn
          row="0"
          colSpan="7"
          dataSort
          headerAlign="left"
        >
          {title}
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="pos"
          width="90"
          headerAlign="center"
          dataAlign="center"
        >
          Puesto
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="number"
          width="7%"
          headerAlign="center"
          dataAlign="center"
        >
          {numberLabel}
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="fullname"
          width="160"
          headerAlign="center"
          dataAlign="center"
        >
          Atleta
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="age"
          width="10%"
          headerAlign="center"
          dataAlign="center"
        >
          Edad
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="category_cod"
          width="10%"
          headerAlign="center"
          dataAlign="center"
        >
          Cat
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="city"
          width="140"
          headerAlign="center"
          dataAlign="center"
        >
          Ciudad
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="time"
          width="10%"
          headerAlign="center"
          dataAlign="right"
        >
          Tiempo
        </TableHeaderColumn>

      </BootstrapTable>
    );
  }


  /*
   * =======================================================
   * PREMIACION GENERAL PEDESTRISMO
   * =======================================================
   */

  renderGeneralAwards() {

    const gralStats =
      Array.isArray(
        this.props.gralStats
      )
        ? this.props.gralStats
        : [];


    if (
      gralStats.length === 0
    ) {

      return null;
    }


    return (

      <ListGroupItem>

        {
          gralStats.map(
            (stat, index) => {

              const distance =
                stat.distancia;


              return (

                <Row
                  key={
                    `general-distance-${distance}-${index}`
                  }
                  className="show-grid"
                >

                  {
                    this.renderPedestrianTable(

                      `fpcd-${distance}-${index}`,

                      `${distance}K - DAMAS PERSONA CON DISCAPACIDAD`,

                      this.getHashPremiacionCategorias(
                        `${distance}FPCD`,
                        5
                      )
                    )
                  }


                  {
                    this.renderPedestrianTable(

                      `mpcd-${distance}-${index}`,

                      `${distance}K - CABALLEROS PERSONA CON DISCAPACIDAD`,

                      this.getHashPremiacionCategorias(
                        `${distance}MPCD`,
                        5
                      )
                    )
                  }


                  {
                    this.renderPedestrianTable(

                      `fsilla-${distance}-${index}`,

                      `${distance}K - DAMAS SILLA DE RUEDAS`,

                      this.getHashPremiacionCategorias(
                        `${distance}FSILLA`,
                        5
                      )
                    )
                  }


                  {
                    this.renderPedestrianTable(

                      `msilla-${distance}-${index}`,

                      `${distance}K - CABALLEROS SILLA DE RUEDAS`,

                      this.getHashPremiacionCategorias(
                        `${distance}MSILLA`,
                        5
                      )
                    )
                  }


                  {
                    this.renderPedestrianTable(

                      `general-female-${distance}-${index}`,

                      `${distance}K DAMAS`,

                      this.getHashPremiacionGeneral(
                        distance,
                        'F',
                        10
                      )
                    )
                  }


                  {
                    this.renderPedestrianTable(

                      `general-male-${distance}-${index}`,

                      `${distance}K CABALLEROS`,

                      this.getHashPremiacionGeneral(
                        distance,
                        'M',
                        10
                      )
                    )
                  }

                </Row>
              );
            }
          )
        }

      </ListGroupItem>
    );
  }


  /*
   * =======================================================
   * PREMIACION LOCAL PEDESTRISMO
   * =======================================================
   */

  renderLocalAwards() {

    const {
      showResultsLocales
    } = this.props;


    const gralStats =
      Array.isArray(
        this.props.gralStats
      )
        ? this.props.gralStats
        : [];


    if (
      showResultsLocales !== true
      ||
      gralStats.length === 0
    ) {

      return null;
    }


    return gralStats.map(
      (stat, index) => {

        const distance =
          stat.distancia;


        return (

          <ListGroupItem
            key={
              `local-awards-${distance}-${index}`
            }
          >

            <Row className="show-grid">

              {
                this.renderPedestrianTable(

                  `local-female-${distance}-${index}`,

                  `${distance}K DAMAS LOCAL`,

                  this.getHashPremiacionGeneralLocal(
                    distance,
                    'F',
                    10
                  )
                )
              }


              {
                this.renderPedestrianTable(

                  `local-male-${distance}-${index}`,

                  `${distance}K CABALLEROS LOCAL`,

                  this.getHashPremiacionGeneralLocal(
                    distance,
                    'M',
                    10
                  )
                )
              }

            </Row>

          </ListGroupItem>
        );
      }
    );
  }


  /*
   * =======================================================
   * CATEGORIA POR EDAD
   * =======================================================
   */

  renderAgeCategoryTable(
    cat,
    distance,
    index
  ) {

    if (
      !cat
    ) {

      return null;
    }


    const category =
      cat.category || '';


    const gender =
      cat.gender || '';


    const range =
      cat.range || '';


    return this.renderPedestrianTable(

      `age-category-${distance}-${category}-${gender}-${index}`,

      `${
        gender === 'F'
          ? 'DAMAS'
          : 'CABALLEROS'
      } ${range}`,

      this.getHashPremiacionCategorias(
        category,
        3
      )
    );
  }


  /*
   * =======================================================
   * SECCION DE CATEGORIAS POR DISTANCIA
   * =======================================================
   */

  renderDistanceCategorySection(
    distanceConfig,
    categories
  ) {

    const distance =
      distanceConfig.value;


    const filteredCategories =
      categories.filter(
        (cat) => {

          if (
            !cat
          ) {

            return false;
          }


          const category =
            String(
              cat.category || ''
            );


          const categoryDistance =
            String(

              cat.distance !== undefined &&
              cat.distance !== null

                ? cat.distance

                : ''

            ).trim();


          return (

            !category.includes(
              'GENERAL'
            )

            &&

            !category.includes(
              'PCD'
            )

            &&

            !category.includes(
              'SILLA'
            )

            &&

            categoryDistance ===
              String(
                distance
              ).trim()
          );
        }
      );


    return (

      <ListGroupItem
        key={
          `distance-section-${distanceConfig.id}-${distance}`
        }
      >

        <Row className="show-grid">

          <Col xs={12} md={12}>

            <ListGroup>

              <ListGroupItem>

                <h4>
                  PREMIACI&Oacute;N {distance}K CATEGOR&Iacute;AS POR EDAD
                </h4>

              </ListGroupItem>


              <ListGroupItem>

                {
                  filteredCategories.length > 0

                    ? filteredCategories.map(
                      (cat, index) => {

                        return this.renderAgeCategoryTable(
                          cat,
                          distance,
                          index
                        );
                      }
                    )

                    : 'Sin categorías'
                }

              </ListGroupItem>

            </ListGroup>

          </Col>

        </Row>

      </ListGroupItem>
    );
  }


  /*
   * =======================================================
   * PREMIACION PEDESTRISMO
   * =======================================================
   */

  renderPedestrianAwards(
    categories
  ) {

    const distances =
      this.getConfiguredDistances();


    return (

      <Row className="show-grid">

        <ListGroup>

          <ListGroupItem>

            <Row className="show-grid">

              <Col xs={12} md={12}>

                <ListGroup>

                  <ListGroupItem>

                    <h4>
                      PREMIACI&Oacute;N CATEGOR&Iacute;A GENERAL
                    </h4>

                  </ListGroupItem>


                  {
                    this.renderGeneralAwards()
                  }


                  {
                    this.renderLocalAwards()
                  }

                </ListGroup>

              </Col>

            </Row>

          </ListGroupItem>


          {
            distances.map(
              (distanceConfig) => {

                return this.renderDistanceCategorySection(
                  distanceConfig,
                  categories
                );
              }
            )
          }

        </ListGroup>

      </Row>
    );
  }


  /*
   * =======================================================
   * TABLA CATEGORIAS COMBINADAS
   * =======================================================
   */

  renderCombinedCategoryTable(
    cat,
    index
  ) {

    const options = {
      noDataText:
        'Sin atletas'
    };


    const key = [

      'combined-category',

      cat.distanceName ||
      cat.distance ||
      'without-distance',

      cat.category ||
      'without-category',

      index

    ].join(
      '-'
    );


    /*
     * PROMOCIONALES
     */
    if (
      cat.category === 'PM'
      ||
      cat.category === 'PF'
      ||
      cat.category === 'PX'
    ) {

      return (

        <BootstrapTable
          key={key}
          data={
            this.getHashPremiacionCategorias(
              cat.category,
              3
            )
          }
          options={options}
        >

          <TableHeaderColumn
            dataField="idx"
            isKey
            hidden
          >
            Puesto
          </TableHeaderColumn>


          <TableHeaderColumn
            row="0"
            colSpan="5"
            dataSort
            headerAlign="left"
          >
            {cat.label}
          </TableHeaderColumn>


          <TableHeaderColumn
            row="1"
            dataField="pos"
            width="5%"
            headerAlign="center"
            dataAlign="center"
          >
            Puesto
          </TableHeaderColumn>


          <TableHeaderColumn
            row="1"
            dataField="number"
            width="5%"
            headerAlign="center"
            dataAlign="center"
          >
            Dorsal
          </TableHeaderColumn>


          <TableHeaderColumn
            row="1"
            dataField="fullname"
            width="40%"
            headerAlign="center"
            dataAlign="center"
          >
            Atletas
          </TableHeaderColumn>


          <TableHeaderColumn
            row="1"
            dataField="category_cod"
            width="15%"
            headerAlign="center"
            dataAlign="center"
          >
            Cat
          </TableHeaderColumn>


          <TableHeaderColumn
            row="1"
            dataField="time"
            width="10%"
            headerAlign="center"
            dataAlign="right"
          >
            Tiempo
          </TableHeaderColumn>

        </BootstrapTable>
      );
    }


    return (

      <BootstrapTable
        key={key}
        data={
          this.getHashPremiacionCategorias(
            cat.category,
            3
          )
        }
        options={options}
      >

        <TableHeaderColumn
          dataField="idx"
          isKey
          hidden
        >
          Puesto
        </TableHeaderColumn>


        <TableHeaderColumn
          row="0"
          colSpan="7"
          dataSort
          headerAlign="left"
        >
          {cat.distanceName} {cat.label}
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="pos"
          width="8%"
          headerAlign="center"
          dataAlign="center"
        >
          Puesto
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="number"
          width="8%"
          headerAlign="center"
          dataAlign="center"
        >
          Dorsal
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="fullname"
          width="20%"
          headerAlign="center"
          dataAlign="center"
        >
          Atleta
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="age"
          width="10%"
          headerAlign="center"
          dataAlign="center"
        >
          Edad
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="category_cod"
          width="10%"
          headerAlign="center"
          dataAlign="center"
        >
          Cat
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="city"
          width="20%"
          headerAlign="center"
          dataAlign="center"
        >
          Ciudad
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="time"
          width="10%"
          headerAlign="center"
          dataAlign="right"
        >
          Tiempo
        </TableHeaderColumn>

      </BootstrapTable>
    );
  }


  /*
   * =======================================================
   * PREMIACION COMBINADAS
   * =======================================================
   */

  renderCombinedAwards(
    categories
  ) {

    const gralStats =
      Array.isArray(
        this.props.gralStats
      )
        ? this.props.gralStats
        : [];


    return (

      <Row className="show-grid">

        <ListGroup>

          <ListGroupItem>
            <h4>
              PREMIACI&Oacute;N GENERAL
            </h4>
          </ListGroupItem>


          <ListGroupItem>

            {
              gralStats.length > 0

                ? gralStats.map(
                  (stat, index) => {

                    const distance =
                      stat.distancia;


                    return (

                      <Row
                        key={
                          `combined-general-${distance}-${index}`
                        }
                        className="show-grid"
                      >

                        <Col xs={12} md={12}>

                          {
                            this.renderPedestrianTable(

                              `combined-female-${distance}-${index}`,

                              `${distance} DAMAS`,

                              this.getHashPremiacionGeneral(
                                distance,
                                'F',
                                10
                              )
                            )
                          }


                          {
                            this.renderPedestrianTable(

                              `combined-male-${distance}-${index}`,

                              `${distance} CABALLEROS`,

                              this.getHashPremiacionGeneral(
                                distance,
                                'M',
                                10
                              )
                            )
                          }

                        </Col>

                      </Row>
                    );
                  }
                )

                : 'Sin atletas'
            }

          </ListGroupItem>


          <ListGroupItem>

            <h4>
              PREMIACI&Oacute;N CATEGOR&Iacute;AS
            </h4>

          </ListGroupItem>


          <ListGroupItem>

            {
              categories.length > 0

                ? categories.map(
                  (cat, index) => {

                    return this.renderCombinedCategoryTable(
                      cat,
                      index
                    );
                  }
                )

                : 'Sin categorías'
            }

          </ListGroupItem>

        </ListGroup>

      </Row>
    );
  }


  /*
   * =======================================================
   * TABLA RURAL BIKE
   * =======================================================
   */

  renderRuralBikeTable(
    cat,
    index
  ) {

    const options = {
      noDataText:
        'Sin atletas'
    };

    console.log(cat)
    return (

      <BootstrapTable
        key={
          `rural-${cat.category}-${cat.distance || ''}-${index}`
        }
        data={
          this.getHashPremiacionCategorias(
            cat.category,
            5
          )
        }
        options={options}
      >

        <TableHeaderColumn
          dataField="idx"
          isKey
          hidden
        >
          Puesto
        </TableHeaderColumn>


        <TableHeaderColumn
          row="0"
          colSpan="8"
          dataSort
          headerAlign="left"
        >
          {cat.label} - {cat.range}
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="pos"
          width="90"
          headerAlign="center"
          dataAlign="center"
        >
          Puesto
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="number"
          width="7%"
          headerAlign="center"
          dataAlign="center"
        >
          Placa
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="fullname"
          width="160"
          headerAlign="center"
          dataAlign="center"
        >
          Ciclista
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="age"
          width="10%"
          headerAlign="center"
          dataAlign="center"
        >
          Edad
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="category_cod"
          width="10%"
          headerAlign="center"
          dataAlign="center"
        >
          Cat
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="club"
          width="140"
          headerAlign="center"
          dataAlign="center"
        >
          Grupo/Club
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="city"
          width="140"
          headerAlign="center"
          dataAlign="center"
        >
          Ciudad
        </TableHeaderColumn>


        <TableHeaderColumn
          row="1"
          dataField="time"
          width="10%"
          headerAlign="center"
          dataAlign="right"
        >
          Tiempo
        </TableHeaderColumn>

      </BootstrapTable>
    );
  }


  /*
   * =======================================================
   * PREMIACION RURAL BIKE
   * =======================================================
   */

  renderRuralBikeAwards(
    categories
  ) {

    return (

      <Row className="show-grid">

        <Col xs={12} md={12}>

          <ListGroup>

            <ListGroupItem>

              {
                categories.length > 0

                  ? categories.map(
                    (cat, index) => {

                      return this.renderRuralBikeTable(
                        cat,
                        index
                      );
                    }
                  )

                  : 'Sin categorías'
              }

            </ListGroupItem>

          </ListGroup>

        </Col>

      </Row>
    );
  }


  /*
   * =======================================================
   * RENDER
   * =======================================================
   */

  render() {

    const {
      competition,
      name,
      date
    } = this.props;


    const catStats =
      Array.isArray(
        this.props.catStats
      )
        ? this.props.catStats
        : [];


    const categories =
      catStats
        .slice()
        .sort(
          (
            category1,
            category2
          ) => {

            const order1 =
              parseInt(
                category1 &&
                category1.order,
                10
              )
              ||
              0;


            const order2 =
              parseInt(
                category2 &&
                category2.order,
                10
              )
              ||
              0;


            return (
              order1 -
              order2
            );
          }
        );


    const isPedestrian =

      competition === Pedestrismo

      ||

      competition === PedestrismoBackup;


    return (

      <Grid className="awards-page">

        <Row className="show-grid">

          <Col md={12}>

            <PageHeader>

              <center>
                PREMIACI&Oacute;N {name}
              </center>


              <small>
                <p>
                  {utilsFormatDate(date)}
                </p>
              </small>

            </PageHeader>

          </Col>

        </Row>


        {
          isPedestrian &&
          this.renderPedestrianAwards(
            categories
          )
        }


        {
          competition === RuralBike &&
          this.renderRuralBikeAwards(
            categories
          )
        }


        {
          competition === CombinadaSimple &&
          this.renderCombinedAwards(
            categories
          )
        }

      </Grid>
    );
  }
}


/*
 * =========================================================
 * REDUX
 * =========================================================
 */

function mapDispatchToProps(
  dispatch
) {

  return bindActionCreators(
    {},
    dispatch
  );
}


function mapStateToProps(
  state
) {

  const {
    infoList,
    participantList,
    catStats,
    gralStats
  } =
    state.reducerRegisterTime;


  const {
    startedAt,
    stoppedAt
  } =
    state.reducerTimer;


  const {
    name,
    date,
    place,

    distance1Type,
    distance1Value,

    distance2Type,
    distance2Value,

    distance3Type,
    distance3Value,

    competition,

    showResultsDistance1,
    showResultsLocales,
    showResults15
  } =
    state.reducerRegisterInfo;


  return {

    infoList:
      Array.isArray(
        infoList
      )
        ? infoList
        : [],


    participantList:
      Array.isArray(
        participantList
      )
        ? participantList
        : [],


    catStats:
      Array.isArray(
        catStats
      )
        ? catStats
        : [],


    gralStats:
      Array.isArray(
        gralStats
      )
        ? gralStats
        : [],


    startedAt,

    stoppedAt,


    name:
      name || '',

    date:
      date || '',

    place:
      place || '',


    distance1Type:
      distance1Type !== undefined &&
      distance1Type !== null

        ? distance1Type

        : '',


    distance1Value:
      distance1Value !== undefined &&
      distance1Value !== null

        ? distance1Value

        : 0,


    distance2Type:
      distance2Type !== undefined &&
      distance2Type !== null

        ? distance2Type

        : '',


    distance2Value:
      distance2Value !== undefined &&
      distance2Value !== null

        ? distance2Value

        : 0,


    distance3Type:
      distance3Type !== undefined &&
      distance3Type !== null

        ? distance3Type

        : '',


    distance3Value:
      distance3Value !== undefined &&
      distance3Value !== null

        ? distance3Value

        : 0,


    competition,

    showResultsDistance1,

    showResultsLocales,

    showResults15
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  RaceInfo
);



// WEBPACK FOOTER //
// ./src/containers/race-info.js